import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import "@microsoft/mgt";
import "react-datepicker/dist/react-datepicker.css";
import "./App.scss";
import {
  onesignalRegister,
  onesignalUnregister,
  handleOneSignalLogin,
  handleOneSignalLogout,
} from "./actions/onesignal";
// import * as serviceWorker from "./serviceWorker";
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

// Export OneSignal functions to window for global access
declare global {
  interface Window {
    onesignalRegister: typeof onesignalRegister;
    onesignalUnregister: typeof onesignalUnregister;
    handleOneSignalLogin: typeof handleOneSignalLogin;
    handleOneSignalLogout: typeof handleOneSignalLogout;
  }
}

window.onesignalRegister = onesignalRegister;
window.onesignalUnregister = onesignalUnregister;

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// if (process.env.NODE_ENV !== "development") {
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
